import React, { useEffect, useRef } from 'react';
import styles from './index.module.scss';
import LottiFile from '@assets/json/Astronaut-with-space-shuttle.json';
import Lottie, { LottieRefCurrentProps } from 'lottie-react';

const StoryLoading = () => {
  const lottieRef = useRef<LottieRefCurrentProps>(null);
  useEffect(() => {
    if (lottieRef.current) {
      lottieRef.current.setSpeed(2);
    }
  }, [lottieRef.current]);
  return (
    <div className={styles['loading']}>
      <div className={styles['animation']}>
        <Lottie lottieRef={lottieRef} animationData={LottiFile} loop autoplay />
      </div>
      <h2 className={styles['title']}>Loading ... </h2>
    </div>
  );
};

export default StoryLoading;
